import { useState, useEffect } from 'react';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import PaymentAuthorizationSubmitButtons from '@Components/Shared/Payments/PaymentAuthorizationSubmitButtons';

const GlobalPaymentsForm = (props) => {
    
    const [paymentForm, setPaymentForm] = useState(null);

    const styles = {
        'input': {
            'border': '1px #ddd solid',
            'padding': '12px',
            'font-family': 'canada-type-gibson, sans-serif',
            'border-radius': '3px',
            'box-sizing': 'border-box',
            'height': '100%',
            'line-height': '100%',
            'color': 'black',
            'outline': 'none',
        },
        'button': {
            'border': 'none',
            'flex': 'none !important',
            'line-height': '0',
            'display': 'block',
            'margin': '0 auto !important',
            'width': '300px !important',
            'height': '51px',
            'background': '#003A5D',
            'padding': '15px',
            'font-family': 'canada-type-gibson, sans-serif',
            'font-size': '18px',
            'font-weight': '700',
            'text-transform': 'uppercase',
            'text-align': 'center',
            'text-decoration': 'none',
            'color': '#fff',
            'border-radius': '5px',
            'cursor': 'pointer'
        },
        'button:hover': {
            'background': '#01273E'
        },
        '.card-number.card-type-visa': {
            'background': '#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right',
            'background-position-y': '0px',
            'background-size': '70px 75px'
        },
        '.card-number.card-type-mastercard': {
            'background': '#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right',
            'background-position-y': '0px',
            'background-size': '80px 80px'
        },
        '.card-number.card-type-discover': {
            'background': '#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right',
            'background-position-y': '0px',
            'background-size': '90px 80px'
        },
        '.card-number.card-type-jcb': {
            'background': '#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right',
            'background-position-y': '0px',
            'background-size': '48px 82px'
        },
        '.card-number.card-type-amex': {
            'background': '#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right',
            'background-position-y': '0px',
            'background-size': '55px 83px'
        },
        'input.invalid': {
            'border-color': '#ff4040'
        }
    };

    useEffect(() => {
        GlobalPayments.configure({
            'X-GP-Api-Key': props.PublicKey,
            'X-GP-Environment': props.LoginID,
            'enableAutocomplete': true
        });

        let fields = {
            'card-number': {
                placeholder: '•••• •••• •••• ••••',
                target: '#credit-card-number'
            },
            'card-expiration': {
                placeholder: 'MM / YYYY',
                target: '#credit-card-expiration'
            },
            'card-cvv': {
                placeholder: '•••',
                target: '#credit-card-cvv'
            },
            'submit': {
                value: 'Submit',
                text: props.submitText || 'Submit',
                target: '#credit-card-submit'
            }
        };

        if (!props.hideNameField) {
            fields['card-holder-name'] = {
                placeholder: 'Full Name',
                target: '#credit-card-holder'
            };
        }

        const form = GlobalPayments.ui.form({
            fields: fields,
            styles: {
                ...styles,
                ...props.styles
            }
        });

        form.ready(() => props.ready?.());

        form.on('token-success', (response) => {
            props.setError(() => '');
            let fullResponse = { ...response, ...props };
            fullResponse.PaymentMethodID = response.temporary_token;
            fullResponse.ExpirationDate = new Date(parseInt(`20${response.card.expiry_year}`), (parseInt(response.card.expiry_month) - 1));
            props.success?.(fullResponse);
        });

        form.on('token-error', () => {
            props.setError(() => 'There was an issue with the card information you entered. Please check your card information and try again.');
            props.setLoading(() => false);
        });

        GlobalPayments.on('error', () => {
            props.setError(() => 'There was an issue with the card information you entered. Please check your card information and try again.');
            props.setLoading(() => false);
        });

        setPaymentForm(form);
    }, []);
    
    const submitForm = () => {
        if (!props.loading) {
            if (typeof props.validateForm === "function") {
                props.validateForm(requestCardToken);
            }
            else {
                requestCardToken();
            }
        }
    };

    const requestCardToken = () => {
        props.setLoading(true);
        paymentForm?.frames?.submit?.events?.click?.[0]?.();
    };

    return (
        <div className='global-payments-pay-fields'>
            <div className='global-payments-form'>
                {props.loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} />}
                <form id='payment-form'>
                    <div className='form-row'>
                        <div className={`form-element ${props.hideNameField && ' hide'}`}>
                            <label>Card Holder Name</label>
                            <div id='credit-card-holder'></div>
                        </div>
                        <div className='form-element'>
                            <label>Card Number</label>
                            <div id='credit-card-number'></div>
                        </div>
                        <div className='form-element'>
                            <label>Expiration</label>
                            <div id='credit-card-expiration'></div>
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='form-element'>
                            <label>CVV</label>
                            <div id='credit-card-cvv'></div>
                        </div>
                    </div>
                    <div id='credit-card-error' className='error' style={{ textAlign: 'center', marginBottom: '15px' }}>
                        {props.error && <>{props.error}</>}
                    </div>
                    {props.validateForm ?
                        <>
                            <PaymentAuthorizationSubmitButtons
                                {...props}
                                submitForm={submitForm}
                            />
                        </>
                        :
                        <div id='credit-card-submit' className={`${props.loading ? 'hide' : ''}`}></div>
                    }
                </form>
            </div>
        </div>
    );
}

export default GlobalPaymentsForm;